import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceVideoTimelines } from '../../services/VideoService';
import { VideoTimeline, VideoTimelineRequest } from '../../types/Videos';

const ONLINE_TIMELINE_POLL_INTERVAL_MS = 60_000;

type UseGetVideoTimelinesOptions = {
  isOnline?: boolean;
};

function useGetVideoTimelines(
  payload: VideoTimelineRequest,
  options: UseGetVideoTimelinesOptions = {},
): UseQueryResult<VideoTimeline> {
  const isOnline = options.isOnline ?? true;

  return useQuery(
    ['video-timelines', payload.deviceId, payload.fleetId, payload.date],
    async (): Promise<VideoTimeline> => getDeviceVideoTimelines(payload),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!payload.deviceId && isOnline,
      refetchInterval: isOnline ? ONLINE_TIMELINE_POLL_INTERVAL_MS : false,
    },
  );
}

export default useGetVideoTimelines;
